import { connect } from "react-redux";
import { default as component } from "./RemoveProjectLink.jsx";

// UI actions
import { dismissModal } from "../../../../common/UI/ActiveModal/duck/actions";
// UI selectors
import { getActiveModal } from "../../../../common/UI/ActiveModal/duck/selectors";

// Local selectors
import { getFocusedLinkForRemoval } from "./duck/selectors";
import { getProjectID } from "../../../duck/selectors.js";

// Local actions
import { removeProjectLink } from "./duck/actions";

const mapStateToProps = (state) => {
  return {
    activeModal: getActiveModal(state),
    projectID: getProjectID(state),
    focusedLink: getFocusedLinkForRemoval(state),
  };
};

const mapDispatchToProps = {
  dismissModal,
  removeProjectLink,
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
